
<template>
  <div>
    <!-- escolhe cliente -->
    <v-autocomplete
      v-model="order.client_id"
      :filter="customFilter"
      :items="all_clients"
      :item-text="formatClientDisplayName"
      item-value="id"
      label="Cliente"
      :loading="loading_clients"
      :readonly='loading_clients'
      prepend-icon="mdi-star"
      :rules="required"
      :menu-props="{ closeOnContentClick: true }"
    >
      <template v-slot:selection="{item}">
        <v-sheet width="100%" class="d-flex flex-column justify-start">
          <span class="d-flex flex-wrap text-wrap">
            {{ formatClientDisplayName(item) }} <span v-if="item.fantasyName">({{ item.fantasyName }})</span>
          </span>
          <div class="d-flex justify-space-between mt-1 align-center text-wrap">
            <span class="d-flex flex-wrap caption text-wrap">ID: {{item.id}}</span>
            <span class="d-flex flex-wrap caption text-wrap">Cidade: {{ item.city }} </span>
          </div>
        </v-sheet>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title class="d-flex flex-wrap text-wrap"> Nome/Fantasia: <b> {{item.fantasyName || formatClientDisplayName(item)}} </b> </v-list-item-title>
          <v-list-item-subtitle class="d-flex flex-wrap text-wrap">Razão Social: <b> {{ formatClientDisplayName(item) }} </b></v-list-item-subtitle>
          <div class="d-flex justify-space-between">
            <div>
              ID: 
              <span :class="['font-weight-bold']">
                {{ item.id }} 
              </span>
            </div>
            <div>
              Cidade: 
              <span :class="['font-weight-bold']">
                {{ item.city }} 
              </span>
            </div>
 
          </div>
          <v-divider class="mt-4"></v-divider>
        </v-list-item-content>
      </template>
    </v-autocomplete>

    <template v-if="loading_client">
      <v-alert type="info" :value="true">
        Carregando detalhes financeiros do cliente...
        <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
      </v-alert>
    </template>

    <template v-if="!loading_client && client">
      <template >
        <v-list two-line subheader v-if="!is_edit">
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-sign-direction</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="d-flex text-wrap"> {{ client.main_address }} </v-list-item-title>
              <v-list-item-subtitle> Endereço Principal </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list> 
      </template>

      <template v-if="client.credits.data.attributes">
        <ClientBlockAlert @credit_updated="getDataAndShowClient()" hide_buttons :client_credit="client.credits" :client="client"></ClientBlockAlert>
      </template> 

    </template>

    <template v-if="!loading_client && client && order.client_id">
      <v-divider></v-divider>
      <ClientLastOrders v-on="$listeners" class="mt-3" :order="order"></ClientLastOrders>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import Api from '@/api/index'
import validations from '@/mixins/validations'
import clientDisplay from '@/mixins/clientDisplay'

export default {
  name:'ClientSelection',
  props: {
    order: {
      type: Object,
    },
    selected_client_id: {
      type: Number,
      default: null
    },
    is_edit: {
      type: Boolean,
      default: false
    },
    modality_id: {
      type: Number,
      default: null
    }
  },
  mixins: [ validations, clientDisplay ],
  components:{
    ClientLastOrders: () => import("./ClientLastOrders.vue"),
    ClientBlockAlert: () => import("@/_backoffice/_registrations/components/shared/client_block/ClientBlockAlert.vue")
  },
  data() {
    return {
      loading_client: false,
      loading_clients: false,
      all_clients: [],
      client: null
    }
  },
  methods: {
    getDataAndShowClient(){
      this.getData()
      this.showClient(this.order.client_id)
    },
    getData(){
      this.getAllClients()
    },
    customFilter(item, queryText, itemText) {
      let { corporateName, fantasyName, name, city, id } = item
      const name_filter = name ? name.toLowerCase() : ''
      const c_name_filter = corporateName ? corporateName.toLowerCase() : ''
      const f_name_filter = fantasyName ? fantasyName.toLowerCase() : ''
      const city_filter = city ? city.toLowerCase() : ''
      const id_filter = String(id)
      const query = queryText.toLowerCase()

      return name_filter.includes(query) || c_name_filter.includes(query) || f_name_filter.includes(query)|| city_filter.includes(query)|| id_filter.includes(query)
    },
    genMainAddress(main){
      let {addr, number, neighborhood, zip, city, state} = main
      return `${addr}, ${number}, ${neighborhood}, ${zip}, ${city}, ${state}`
    },
    getAllClients() {
      if (this.modality_id || this.activeModalityId){
        this.loading_clients = true
        let filter = {short: true, modality_id: this.modality_id || this.activeModalityId }
        
        Api.Client.index(filter).then(r => r.data).then(r => {
          r = r.data? r.data.map(d => d.attributes) : r
          // filtra para nao exibir os clientes com os ids referentes ao final client e own client do galpao
          // IDS DOS CLIENTES DOS GALPÕES
          const ownClientIds = [278, 3648, 3644, 3646, 1675, 3295, 3868, 4285, 4847, 5779]
          this.all_clients = [...r.filter(el => {
            const label = `${el.name || ''} ${el.corporateName || ''}`.toLowerCase()
            return !label.includes('cliente final') && !ownClientIds.includes(el.id) && !el.modality_id
          })]

          if(this.order.client_id == null){
            this.order.client_id = this.selected_client_id
          }
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{
          this.loading_clients = false
        })
      }
    },
    showClient(id){
      this.loading_client = true
      let params = {short: true}
      Api.Client.show({id, params}).then(r => {
        this.client = {...r.data.data?.attributes}
        this.order.employee_id = null
        this.order.manager_id = null
        this.order.client = this.client
        this.order.client_name = this.client.name
        this.$emit('canUseClient', this.client.credits.data.attributes.status_id != 10)
        this.mapClientDefaultPayments()
      }).catch(err=>{
        console.log(err);
      }).finally(()=>{
        this.loading_client = false
      })
    },
    mapClientDefaultPayments(){
      // Se tiver algum método padrão de pagamento, ele faz o map para colcoar na lista de pagamento
      if(this.client.default_client_payments.length > 0){
        let had_limit = this.order.client.credits.data.attributes.status_id != 10
        this.order.payments.list = [...this.client.default_client_payments.map(el => {
          return {
            payment_option_id: had_limit ? el.payment_option_id : null,
            payment_time_id: had_limit ? el.payment_time_id : null,
            ammount: '0.00',
            percentage: el.percentage,
            ref: Math.round(Math.random()*10000),
          }
        })]
      }else{
        this.order.payments.list = [
          {
            payment_option_id: null,
            payment_time_id: null,
            ammount: '0.00',
            percentage: 100,
            ref: Math.round(Math.random()*10000),
          }
        ]
      }
    },
  },
  mounted () {
    this.getData()
  },
  watch: {
    'order.client_id'(nv) {
      if (nv) {
        this.showClient(nv)
      }
    },
    activeModalityId(){
      this.getData()
    },
    modality_id(){
      this.getData()
    }
  },
}
</script>